import { type PropsWithChildren } from 'react';
import styles from './ApplyLayout.module.scss';

const ApplyLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default ApplyLayout;
